export const content = state => {
  return state.content;
};
export const hero = state => {
  return state.hero;
};
export const scrollInfo = state => {
  return state.scrollInfo;
};
export const teams = state => {
  return state.teams;
};
export const footer = state => {
  return state.footer;
};
